import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    title: {
        fontWeight: 700,
        color: '#2c4767',
        fontSize: '1.15rem',
        position: 'relative',
        paddingBottom: theme.spacing(1),
        marginBottom: theme.spacing(1.5),
        '&::after': {
            content: '""',
            position: 'absolute',
            left: 0,
            bottom: 0,
            width: 40,
            height: 2,
            background: '#b08d57',
            borderRadius: 1,
        },
    },
}));

export default function Title(props) {
    const classes = useStyles();
    return (
        <Typography component="h2" variant="h6" className={classes.title} gutterBottom>
            {props.children}
        </Typography>
    );
}

Title.propTypes = {
    children: PropTypes.node,
};
